module.exports = __webpack_public_path__ + "static/media/assured-horizontal.bfd57bcd.png";